import { TemplateHandler } from 'easy-template-x'
import StorageService from './StorageService'

export default class DocumentService extends StorageService {

  async generateDoc(item: any) {

    const templatePath = item.templatePath

    // clean up item
    item.added = this.$moment(item.added).format('YYYY-MM-DD')
    item.updated = this.$moment(item.updated).format('YYYY-MM-DD')

    const arr: any = []
    item.tags.forEach((tag: string) => {
      arr.push({ 'name': tag })
    });
    item.tags = arr;

    // additional props
    item['currentDate'] = this.$moment(new Date()).format('YYYY-MM-DD')
    item['userFirstName'] = item.user.firstName ? item.user.firstName : '';
    item['userLastName'] = item.user.lastName ? item.user.lastName : '';
    item['companyName'] = item.company.companyName ? item.company.companyName : '';
    item['companyNumber'] = item.company.companyNumber ? item.company.companyNumber : '';
    item['companyCountry'] = item.company.country ? item.company.country : '';
    item['companyCity'] = item.company.city ? item.company.city : '';
    item['companyAddress'] = item.company.address ? item.company.address : '';

    delete item.user; // obj
    delete item.company; // obj
    delete item.companyId;
    delete item.projectId;
    delete item.id;
    delete item.updatedBy;
    delete item.templatePath;

    // read template file
    //const response = await fetch('https://firebasestorage.googleapis.com/v0/b/apif-prod.appspot.com/o/templates%2Fpif%2Fbalmid.docx?alt=media&token=d5d049fa-3f12-4ab6-a44d-09ac78444b95')
    const url = await this.getDownloadURL(templatePath)
    const response = await fetch(url)
    const templateFile = await response.blob()

    // process the template
    const handler = new TemplateHandler()
    const doc = await handler.process(templateFile, item)

    // save output
    this.saveFile('apif - ' + item.productName + '.docx', doc)
  }

  async saveFile(filename: any, blob: any) {

    // get downloadable url from the blob
    const blobUrl = URL.createObjectURL(blob);

    // create temp link element
    const link = document.createElement("a");
    link.download = filename;
    link.href = blobUrl;

    // use the link to invoke a download
    document.body.appendChild(link);
    link.click();

    // remove the link
    setTimeout(() => {
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    }, 0);
  }

  flattenObject(ob: any, prefix: any = false, result: any = null) {
    result = result || {};

    // Preserve empty objects and arrays, they are lost otherwise
    if (typeof ob === 'object' && ob !== null && Object.keys(ob).length === 0) {
      result[prefix] = Array.isArray(ob) ? [] : {};
      return result;
    }

    prefix = prefix ? prefix + '.' : '';

    for (const i in ob) {
      if (Object.prototype.hasOwnProperty.call(ob, i)) {
        if (typeof ob[i] === 'object' && ob[i] !== null) {
          // Recursion on deeper objects
          this.flattenObject(ob[i], prefix + i, result);
        } else {
          result[prefix + i] = ob[i];
        }
      }
    }
    return result;
  }

}